import ts from "typescript";
import { createAst } from "./factory";
export var startOfJsxNode = function (code, source) {
    return startOfJsxIdentifier(code, source) - 1;
};
export function startOfJsxIdentifier(code, source) {
    var sourceLines = code.split("\n");
    if (source.lineNumber > 0 && source.lineNumber < sourceLines.length) {
        var lineIndex = source.lineNumber - 1;
        var start = 0;
        for (var i = 0; i < lineIndex; ++i) {
            var line = sourceLines[i];
            start += line.length + 1;
        }
        start += source.columnNumber - 1;
        // Here i intentionaly add 1 to the start variable to move from start of JSXElement
        // to start of StringLiteral, because of discovered bug in typescript AST
        start += 1;
        return start;
    }
    return null;
}
export function astFindStart(code, start) {
    var ast = createAst(code);
    var callback = function (node) {
        var nodeStart = node.pos;
        if (nodeStart <= start && start <= node.end) {
            if (nodeStart === start) {
                // node.kind == ts.SyntaxKind.JsxElement
                return node;
            }
            return ts.forEachChild(node, callback);
        }
        return null;
    };
    if (ast) {
        var found = ts.forEachChild(ast, callback);
        return found;
    }
    return null;
}
export var codeStart = function (code, source) {
    var identifierStart = startOfJsxIdentifier(code, source);
    if (!identifierStart)
        return null;
    var identifierNode = astFindStart(code, identifierStart);
    if (!identifierNode)
        return null;
    // return pos of parent if element is self closing element, otherwise return position of grandparent
    if (ts.isJsxSelfClosingElement(identifierNode.parent))
        return identifierNode.parent.pos;
    if (ts.isJsxOpeningElement(identifierNode.parent))
        return identifierNode.parent.parent.pos;
};
export function astFindSource(code, source) {
    var start = codeStart(code, source);
    if (start) {
        var found = astFindStart(code, start);
        return found;
        //sourceLines.splice(lineIndex, 0, sourceLine);
        //const newContent = sourceLines.join('\n');
        //return newContent;
    }
    return null;
}
export var findElementInCode = function (code, source) {
    var found = astFindSource(code, source);
    if (found) {
        var before = code.substring(0, found.end);
        var startEndOfLine = before.lastIndexOf("\n");
        var lineStarts = startEndOfLine >= 0 ? startEndOfLine : 0;
        return code.substring(lineStarts, found.end);
    }
    return null;
};
export var getAstAndNodeFromSource = function (code, source) {
    var node = astFindSource(code, source);
    var ast = createAst(code);
    return { node: node, ast: ast };
};
export var findByCondition = function (node, condition) {
    if (condition(node)) {
        return node;
    }
    ;
    return node.forEachChild(function (child) {
        return findByCondition(child, condition);
    });
};
export var findAllByCondition = function (node, output, condition) {
    if (condition(node)) {
        output.push(node);
    }
    ;
    return node.forEachChild(function (child) {
        return findAllByCondition(child, output, condition);
    });
};
